<template>
  <dv-scroll-board :config="config" style="width:100%;height:100%;" />
</template>
<script>
export default {
  name: "List1",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {

    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };

    this.$api.zq_company_list(data).then(res=>
    {
      this.config = {
        header: ['消费者', '购买产品', '购买金额', '帮扶金额', '帮扶地点'],
        rowNum:[6],
        data: res,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [30,150,175],
        align: ['center']
      }
    })


  },

  watch: {

  }
}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>